// extracted by mini-css-extract-plugin
export default {"container":"EventsDisplaySection_container__+7i+h"};